import "./global.js";

export default "./global.js";
